import { AppConfig } from '@dh-io-emh/config-types';
import { createHttpService } from '../utils/http.util';

export type ToasApi = ReturnType<typeof createToasApi>;

export type LegalTextCiam = {
  title: string;
  legalText: string;
};

export const createToasApi = ({ config: { locale, shopCountry, toasApiBaseUrl } }: { config: AppConfig }) => {
  const http = createHttpService({
    url: toasApiBaseUrl,
  });

  return {
    getLegalNotices: async (): Promise<LegalTextCiam | null> => {
      const { data } = await http.get<LegalTextCiam | null>('contract/legal-texts-ciam', {
        params: {
          region: shopCountry,
          language: locale,
        },
      });

      return data;
    },
  };
};
